var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBtnAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.944,
    height: 9.944,
    viewBox: "0 0 9.944 9.944",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.056,4.084H6.037a.178.178,0,0,1-.178-.178V.888a.888.888,0,0,0-1.776,0V3.907a.178.178,0,0,1-.178.178H.888a.888.888,0,0,0,0,1.776H3.907a.178.178,0,0,1,.178.178V9.056a.888.888,0,0,0,1.776,0V6.037a.178.178,0,0,1,.178-.178H9.056a.888.888,0,0,0,0-1.776Zm0,0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnAdd);
export default __webpack_public_path__ + "static/media/btn_add.e9a694611d13d7d78d70a410d5398cd0.svg";
export { ForwardRef as ReactComponent };